import Vue from 'vue';
import Router from 'vue-router';
import store from './store/store';

import TaskManage from './views/TaskManage.vue';
import PaperCheck from './views/PaperCheck.vue';
import MyCheckInfo from './views/MyCheckInfo.vue';
import Pdf from '@/components/Pdf.vue';

Vue.use(Router);

const constRouterMap: any = [];
export const asyncRouterMap = [{
    path: '/paperCheck',
    alias: '/',
    name: 'paperCheck',
    component: PaperCheck,
    meta: {
      title: '文献送检',
      role: ['Master', 'SubAccount']
    }
  }, {
    path: '/myCheckInfo',
    name: 'myCheckInfo',
    component: MyCheckInfo,
    meta: {
      title: '结果查询',
      role: ['Master']
    }
  }, {
    path: '/taskManage',
    name: 'taskManage',
    component: TaskManage,
    meta: {
      title: '文件夹管理',
      role: ['Master', 'SubAccount']
    }
  }, {
    path: '/pdf',
    name: 'pdf',
    component: Pdf,
    meta: {
      title: 'pdf',
      role: ['Master', 'SubAccount']
    }
  }, {
    path: '/error',
    name: 'error',
    component: () => import('./views/Error.vue'),
    meta: {
      role: ['Master', 'SubAccount']
    }
  }
];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: constRouterMap
});

export default router;
